import { createSelector } from 'reselect'

const getCustomFields = (customFields, role, association, projectId) => (customFields || [])
    .filter(customField =>
        !customField.removed &&
        (!association || customField.associations?.includes(association)) &&
        (role === 'owner' || !customField.hidden?.includes(role)) &&
        (!projectId || customField.projects?.includes(projectId))
    ).sort((s1, s2) => {
        const s1Name = (s1.name && s1.name.toLowerCase());
        const s2Name = (s2.name && s2.name.toLowerCase());

        if (s1Name > s2Name) return 1;
        if (s1Name < s2Name) return -1;

        return 0;
    });
export const makeGetCustomFields = () => createSelector(getCustomFields, customFields => customFields);

const getLibraryCustomFields = (customFields, role, association, projectId) => customFields
    .filter(customField =>
        !customField.removed &&
        customField.in_library &&
        (!association || customField.associations?.includes(association)) &&
        (role === 'owner' || !customField.hidden?.includes(role)) &&
        !(projectId || customField.projects?.includes(projectId))
    );
export const makeGetLibraryCustomFields = () => createSelector(getLibraryCustomFields, customFields => customFields);

const getCustomFieldsByType = (customFields, types) => (customFields || [])
    .filter(customField => types.includes(customField.type));
export const makeGetCustomFieldsByType = () => createSelector(getCustomFieldsByType, customFields => customFields);

const getCustomField = (customFields, id) => customFields.find(customField => customField.id === id);
export const makeGetCustomField = () => createSelector(getCustomField, customField => customField);
